import React, { FC, ReactNode } from 'react'
import DatePicker, { CalendarProps } from 'react-multi-date-picker'
import { months, weekDays } from '@/const/calendar'

export interface ICalendar extends CalendarProps {
  name?: string
  children?: ReactNode
  onOpenPickNewDate?: boolean
}

const Calendar: FC<ICalendar> = ({ format = 'DD.MM.YYYY', children, onOpenPickNewDate = true, ...props }) => {
  return (
    <DatePicker
      format={format}
      weekStartDayIndex={1}
      weekDays={weekDays}
      months={months}
      onOpenPickNewDate={onOpenPickNewDate}
      {...props}
    >
      {children}
    </DatePicker>
  )
}

export default Calendar
